// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__qykJV","listGridLayout":"List_listGridLayout__XSS1s","listFlexLayout":"List_listFlexLayout__iob0k"};